"use strict";

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es7.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteDonationAction = exports.editDonationAction = exports.addDonationAction = exports.resetDirectorVideoUpload = exports.editDecedentPhoneAction = exports.startUploadDirectorVideo = exports.selectDirectorVideo = exports.deleteInviteAction = exports.sendMemorialLinkResetAction = exports.sendMemorialLinkAction = exports.inviteResetAction = exports.finishCreationAction = exports.editThemeAction = exports.editFuneralInfoResetAction = exports.editFuneralInfoAction = exports.editObituaryAction = exports.addObituaryAction = exports.addNoServiceOptionsAction = exports.getLocationsList = exports.deleteServiceAction = exports.editServiceAction = exports.addServiceAction = exports.resetAccessorErrorAction = exports.removeAccessorAction = exports.editAccessorAction = exports.addAccessorAction = exports.editDecedentDetailsAction = exports.fetchUnfinishedMemorialAction = exports.startInviteCreationAction = exports.resetInviteCreation = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.promise.js");

var _actions = require("./actions");

var _constants = require("../../constants");

var _index = _interopRequireDefault(require("axios/index"));

var _transformAxiosError = _interopRequireDefault(require("@evdy/web-etc/dist/lib/transformAxiosError"));

var _utils = require("@evdy/web-core/dist/lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var instance = _index.default.create({
  baseURL: "".concat(_constants.API_URL)
}); // Reset Invite Creation


var resetInviteCreation = function resetInviteCreation() {
  return function (dispatch) {
    dispatch(_actions.resetInviteCreationAction);
  };
}; // Start Invite Creation


exports.resetInviteCreation = resetInviteCreation;

var startInviteCreationAction = function startInviteCreationAction(memorial) {
  return function (dispatch) {
    dispatch((0, _actions.startInviteCreationRequest)());
    return instance.post('/v2/private/memorial', memorial).then(function (res) {
      return dispatch((0, _actions.startInviteCreationSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.startInviteCreationFailure)((0, _transformAxiosError.default)(err)));
    });
  };
}; // Fetch Unfinished Memorial


exports.startInviteCreationAction = startInviteCreationAction;

var fetchUnfinishedMemorialAction = function fetchUnfinishedMemorialAction(_ref) {
  var memorialId = _ref.memorialId,
      showAllEvents = _ref.showAllEvents;
  return function (dispatch) {
    dispatch((0, _actions.fetchUnfinishedInviteRequest)());
    return instance.get("/v2/private/memorial/".concat(memorialId), {
      params: {
        showAllEvents: showAllEvents
      }
    }).then(function (res) {
      return dispatch((0, _actions.fetchUnfinishedInviteSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.fetchUnfinishedInviteFailure)((0, _transformAxiosError.default)(err)));
    });
  };
}; // Edit Decedent Details


exports.fetchUnfinishedMemorialAction = fetchUnfinishedMemorialAction;

var editDecedentDetailsAction = function editDecedentDetailsAction(_ref2) {
  var memorialId = _ref2.memorialId,
      decedent = _ref2.decedent;
  return function (dispatch) {
    dispatch((0, _actions.editDecedentDetailsRequest)());

    var _ref3 = decedent || {},
        name = _ref3.name,
        dateOfBirth = _ref3.dateOfBirth,
        dateOfDeath = _ref3.dateOfDeath,
        requestedDisplayName = _ref3.displayName;

    var searchName = (0, _utils.nameString)(name || null);
    var isValidDisplayName = requestedDisplayName && requestedDisplayName.trim() !== '';
    var displayName = isValidDisplayName ? requestedDisplayName : (0, _utils.nameString)(name);

    var body = _objectSpread(_objectSpread({}, decedent), {}, {
      searchName: searchName,
      displayName: displayName,
      dateOfBirth: dateOfBirth && new Date(dateOfBirth).getTime(),
      dateOfDeath: dateOfDeath && new Date(dateOfDeath).getTime()
    });

    return instance.put("/v2/private/memorial/".concat(memorialId, "/hero"), body).then(function (res) {
      return dispatch((0, _actions.editDecedentDetailsSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.editDecedentDetailsFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.editDecedentDetailsAction = editDecedentDetailsAction;

var editDecedentPhoneAction = function editDecedentPhoneAction(_ref4) {
  var memorialId = _ref4.memorialId,
      decedentPhone = _ref4.decedentPhone;
  return function (dispatch) {
    dispatch((0, _actions.editDecedentPhoneRequest)());
    return instance.put("/v2/private/memorial/".concat(memorialId, "/decedentphone"), {
      decedentPhone: decedentPhone
    }).then(function (res) {
      return dispatch((0, _actions.editDecedentPhoneSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.editDecedentPhoneFailure)(err));
    });
  };
}; // Accessors


exports.editDecedentPhoneAction = editDecedentPhoneAction;

var addAccessorAction = function addAccessorAction(_ref5) {
  var memorialId = _ref5.memorialId,
      newAccessors = _ref5.newAccessors;
  return function (dispatch) {
    dispatch((0, _actions.addAccessorRequest)());
    return instance.post("/v2/private/memorial/".concat(memorialId, "/accessors"), {
      accessors: newAccessors,
      from: 'dash'
    }).then(function (res) {
      return dispatch((0, _actions.addAccessorSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.addAccessorFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.addAccessorAction = addAccessorAction;

var editAccessorAction = function editAccessorAction(_ref6) {
  var memorialId = _ref6.memorialId,
      accessor = _ref6.accessor;
  return function (dispatch) {
    var accessorId = accessor._id;
    dispatch((0, _actions.editAccessorRequest)());
    return instance.put("/v2/private/memorial/".concat(memorialId, "/accessors/").concat(accessorId), accessor).then(function (res) {
      return dispatch((0, _actions.editAccessorSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.editAccessorFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.editAccessorAction = editAccessorAction;

var removeAccessorAction = function removeAccessorAction(_ref7) {
  var memorialId = _ref7.memorialId,
      accessorId = _ref7.accessorId;
  return function (dispatch) {
    dispatch(_actions.removeAccessorRequest);
    return instance.delete("/v2/private/memorial/".concat(memorialId, "/accessors/").concat(accessorId)).then(function (res) {
      return dispatch((0, _actions.removeAccessorSuccess)(res));
    }, function (err) {
      return dispatch((0, _actions.removeAccessorFailure)(err));
    });
  };
};

exports.removeAccessorAction = removeAccessorAction;

var resetAccessorErrorAction = function resetAccessorErrorAction() {
  return function (dispatch) {
    dispatch(_actions.resetDupeAccessorError);
  };
}; // Services


exports.resetAccessorErrorAction = resetAccessorErrorAction;

var addServiceAction = function addServiceAction(_ref8) {
  var memorialId = _ref8.memorialId,
      service = _ref8.service;
  return function (dispatch) {
    dispatch((0, _actions.addServiceRequest)());
    return instance.post("/v2/private/memorial/".concat(memorialId, "/service"), service).then(function (res) {
      return dispatch((0, _actions.addServiceSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.addServiceFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.addServiceAction = addServiceAction;

var editServiceAction = function editServiceAction(_ref9) {
  var memorialId = _ref9.memorialId,
      service = _ref9.service;
  return function (dispatch) {
    var serviceId = service._id,
        notify = service.notify;
    dispatch((0, _actions.editServiceRequest)());

    var notifyCommunity = function notifyCommunity() {
      return !!notify ? "/?notify=true" : '';
    };

    return instance.put("/v2/private/memorial/".concat(memorialId, "/service/").concat(serviceId).concat(notifyCommunity()), service).then(function (res) {
      return dispatch((0, _actions.editServiceSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.editServiceFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.editServiceAction = editServiceAction;

var getLocationsList = function getLocationsList(_ref10) {
  var funeralHomeId = _ref10.funeralHomeId,
      input = _ref10.input,
      coords = _ref10.coords;
  return function (dispatch) {
    dispatch((0, _actions.getLocationsRequest)());
    var params = {
      input: input,
      funeralHomeId: funeralHomeId,
      coords: coords
    };
    return instance.get("/v2/search/places/", {
      params: params
    }).then(function (res) {
      return dispatch((0, _actions.getLocationsSuccess)(res));
    }, function (err) {
      return dispatch((0, _actions.getLocationsFailure)(err));
    });
  };
};

exports.getLocationsList = getLocationsList;

var deleteServiceAction = function deleteServiceAction(_ref11) {
  var memorialId = _ref11.memorialId,
      serviceId = _ref11.serviceId;
  return function (dispatch) {
    dispatch(_actions.deleteServiceRequest);
    return instance.delete("/v2/private/memorial/".concat(memorialId, "/service/").concat(serviceId)).then(function (res) {
      return dispatch((0, _actions.deleteServiceSuccess)(res));
    }, function (err) {
      return dispatch((0, _actions.deleteServiceFailure)(err));
    });
  };
};

exports.deleteServiceAction = deleteServiceAction;

var addNoServiceOptionsAction = function addNoServiceOptionsAction(_ref12) {
  var memorialId = _ref12.memorialId,
      noServices = _ref12.noServices;
  return function (dispatch) {
    dispatch(_actions.addNoServiceOptionsRequest);
    var body = {
      serviceStatus: noServices
    };
    return instance.put("/v2/private/memorial/".concat(memorialId, "/servicestatus"), body).then(function (res) {
      return dispatch((0, _actions.addNoServiceOptionsSuccess)(res));
    }, function (err) {
      return dispatch((0, _actions.addNoServiceOptionsFailure)(err));
    });
  };
}; // Obituary


exports.addNoServiceOptionsAction = addNoServiceOptionsAction;

var addObituaryAction = function addObituaryAction(_ref13) {
  var memorialId = _ref13.memorialId,
      message = _ref13.message;
  return function (dispatch) {
    dispatch((0, _actions.addObituaryRequest)());
    return instance.post("/v2/private/memorial/".concat(memorialId, "/obituary"), {
      obituary: message
    }).then(function (res) {
      return dispatch((0, _actions.addObituarySuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.addObituaryFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.addObituaryAction = addObituaryAction;

var editObituaryAction = function editObituaryAction(_ref14) {
  var memorialId = _ref14.memorialId,
      message = _ref14.message;
  return function (dispatch) {
    dispatch((0, _actions.editObituaryRequest)());
    return instance.post("/v2/private/memorial/".concat(memorialId, "/obituary"), {
      obituary: message
    }).then(function (res) {
      return dispatch((0, _actions.editObituarySuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.editObituaryFailure)((0, _transformAxiosError.default)(err)));
    });
  };
}; // Donation


exports.editObituaryAction = editObituaryAction;

var addDonationAction = function addDonationAction(_ref15) {
  var memorialId = _ref15.memorialId,
      title = _ref15.title,
      description = _ref15.description,
      url = _ref15.url;
  return function (dispatch) {
    dispatch((0, _actions.addDonationRequest)());
    return instance.post("/v2/private/memorial/".concat(memorialId, "/donation"), {
      title: title,
      description: description,
      url: url
    }).then(function (res) {
      return dispatch((0, _actions.addDonationSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.addDonationFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.addDonationAction = addDonationAction;

var editDonationAction = function editDonationAction(_ref16) {
  var memorialId = _ref16.memorialId,
      donationId = _ref16.donationId,
      title = _ref16.title,
      description = _ref16.description,
      url = _ref16.url;
  return function (dispatch) {
    dispatch((0, _actions.editDonationRequest)());
    return instance.put("/v2/private/memorial/".concat(memorialId, "/donation/").concat(donationId), {
      title: title,
      description: description,
      url: url
    }).then(function (res) {
      return dispatch((0, _actions.editDonationSuccess)(res));
    }).catch(function (err) {
      return (0, _actions.editDonationFailure)((0, _transformAxiosError.default)(err));
    });
  };
};

exports.editDonationAction = editDonationAction;

var deleteDonationAction = function deleteDonationAction(_ref17) {
  var memorialId = _ref17.memorialId,
      donationId = _ref17.donationId;
  return function (dispatch) {
    dispatch((0, _actions.deleteDonationRequest)());
    return instance.delete("/v2/private/memorial/".concat(memorialId, "/donation/").concat(donationId)).then(function (res) {
      return dispatch((0, _actions.deleteDonationSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.deleteDonationFailure)((0, _transformAxiosError.default)(err)));
    });
  };
}; // Funeral Info


exports.deleteDonationAction = deleteDonationAction;

var editFuneralInfoAction = function editFuneralInfoAction(_ref18) {
  var memorialId = _ref18.memorialId,
      funeralHomeId = _ref18.funeralHomeId,
      funeralDirectorId = _ref18.funeralDirectorId,
      funeralDirectorCreator = _ref18.funeralDirectorCreator;
  return function (dispatch) {
    dispatch((0, _actions.editFuneralInfoRequest)());

    var data = _objectSpread({
      funeralHome: funeralHomeId,
      funeralDirectorId: funeralDirectorId
    }, funeralDirectorCreator && {
      funeralDirectorCreator: funeralDirectorCreator
    });

    return instance.put("/v2/private/memorial/".concat(memorialId, "/funeralinfo"), data).then(function (res) {
      return dispatch((0, _actions.editFuneralInfoSuccess)(res.data));
    }).catch(function (err) {
      return dispatch((0, _actions.editFuneralInfoFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.editFuneralInfoAction = editFuneralInfoAction;

var editFuneralInfoResetAction = function editFuneralInfoResetAction() {
  return function (dispatch) {
    return dispatch((0, _actions.editFuneralInfoReset)());
  };
}; // Theme


exports.editFuneralInfoResetAction = editFuneralInfoResetAction;

var editThemeAction = function editThemeAction(_ref19) {
  var memorialId = _ref19.memorialId,
      themeIdx = _ref19.themeIdx;
  return function (dispatch) {
    dispatch((0, _actions.editThemeRequest)());
    return instance.put("/v2/private/memorial/".concat(memorialId, "/theme"), {
      themeIdx: themeIdx
    }).then(function (res) {
      return dispatch((0, _actions.editThemeSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.editThemeFailure)((0, _transformAxiosError.default)(err)));
    });
  };
}; // Finish/Finalize Creation


exports.editThemeAction = editThemeAction;

var finishCreationAction = function finishCreationAction(_ref20) {
  var memorialId = _ref20.memorialId,
      customSMS = _ref20.customSMS;
  return function (dispatch) {
    dispatch((0, _actions.finishInviteCreationRequest)());
    return instance.post("/v2/private/memorial/".concat(memorialId, "/finalize")).then(function (res) {
      return dispatch((0, _actions.finishInviteCreationSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.finishInviteCreationFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.finishCreationAction = finishCreationAction;

var inviteResetAction = function inviteResetAction() {
  return function (dispatch) {
    return dispatch((0, _actions.inviteReset)());
  };
}; // TODO - doesn't appear to be used - Marc 4.21.20
// Send Memorial Link SMS


exports.inviteResetAction = inviteResetAction;

var sendMemorialLinkAction = function sendMemorialLinkAction(_ref21) {
  var memorialId = _ref21.memorialId;
  return function (dispatch) {
    dispatch((0, _actions.sendMemorialLinkRequest)());
    return instance.post("/v2/private/memorial/".concat(memorialId, "/sendmemorialsmslink")).then(function (res) {
      return dispatch((0, _actions.sendMemorialLinkSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.sendMemorialLinkFailure)((0, _transformAxiosError.default)(err)));
    });
  };
};

exports.sendMemorialLinkAction = sendMemorialLinkAction;

var sendMemorialLinkResetAction = function sendMemorialLinkResetAction() {
  return function (dispatch) {
    return dispatch((0, _actions.sendMemorialLinkReset)());
  };
}; // Delete Invite


exports.sendMemorialLinkResetAction = sendMemorialLinkResetAction;

var deleteInviteAction = function deleteInviteAction(_ref22) {
  var memorialId = _ref22.memorialId;
  return function (dispatch) {
    dispatch((0, _actions.deleteInviteRequest)());
    return instance.delete("/v2/private/memorial/".concat(memorialId)).then(function (res) {
      return dispatch((0, _actions.deleteInviteSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.deleteInviteFailure)((0, _transformAxiosError.default)(err)));
    });
  };
}; //selectDirectorVideo


exports.deleteInviteAction = deleteInviteAction;

var selectDirectorVideo = function selectDirectorVideo(_ref23) {
  var memorialId = _ref23.memorialId,
      directorVideoUrl = _ref23.directorVideoUrl,
      idx = _ref23.idx;
  return function (dispatch) {
    dispatch((0, _actions.selectDirectorVideoRequest)());
    return instance.post("/v2/private/memorial/".concat(memorialId, "/directorvideo"), {
      directorVideoUrl: directorVideoUrl,
      idx: idx
    }).then(function (res) {
      return dispatch((0, _actions.selectDirectorVideoSuccess)(res));
    }).catch(function (err) {
      return dispatch((0, _actions.selectDirectorVideoFailure)(err));
    });
  };
};

exports.selectDirectorVideo = selectDirectorVideo;
var streamProps = {
  handler: undefined,
  dispatch: undefined,
  file: undefined
};

var handleUploadNextSlice = function handleUploadNextSlice(_ref24) {
  var percent = _ref24.percent,
      place = _ref24.place,
      sliceAmt = _ref24.sliceAmt;
  var reader = new FileReader();
  streamProps.dispatch((0, _actions.setUploadProgress)(percent));
  var uploadPosition = place * sliceAmt;
  var newSlice = streamProps.file.slice(uploadPosition, uploadPosition + Math.min(sliceAmt, streamProps.file.size - uploadPosition));
  reader.readAsBinaryString(newSlice);

  reader.onload = function (_ref25) {
    var target = _ref25.target;
    streamProps.handler.emit('event://upload-new-video-slice', {
      name: streamProps.file.name,
      data: target.result
    });
  };
};

var handleFinishUpload = function handleFinishUpload(_ref26) {
  var memorial = _ref26.memorial,
      thumbnailUrl = _ref26.thumbnailUrl;
  streamProps.handler.emit('uploadDisconnect');
  streamProps.dispatch((0, _actions.setUploadInProgress)(false));
  streamProps.dispatch((0, _actions.setUploadProgress)(null));
  streamProps.dispatch((0, _actions.setUploadThumbnail)(thumbnailUrl));
  streamProps.dispatch((0, _actions.selectDirectorVideoSuccess)({
    data: {
      data: memorial
    }
  }));
  streamProps.handler.removeEventListener('event://ready-for-next-video-slice', handleUploadNextSlice);
  streamProps.handler.removeEventListener('event://finished-video-upload', handleFinishUpload);
  streamProps = {
    handler: undefined,
    dispatch: undefined,
    file: undefined
  };
};

var getVideoDuration = function getVideoDuration(file) {
  var fileURL = URL.createObjectURL(file);
  var video = document.createElement('video');
  video.setAttribute('src', fileURL);
  return new Promise(function (res) {
    video.onloadedmetadata = function () {
      return res(video.duration);
    };
  });
};

var startUploadDirectorVideo = function startUploadDirectorVideo(_ref27) {
  var handler = _ref27.handler,
      file = _ref27.file,
      memorialId = _ref27.memorialId;
  return /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var duration, durationInMin;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getVideoDuration(file);

            case 2:
              duration = _context.sent;

              if (duration > 10 * 60) {
                durationInMin = (duration / 60).toFixed(1);
                dispatch((0, _actions.invalidUploadDuration)("Selected video is too long: ".concat(durationInMin, "min > 10min")));
              } else if (duration < 1) {
                dispatch((0, _actions.invalidUploadDuration)('Selected video is less an one sec long'));
              } else {
                if (handler) {
                  dispatch((0, _actions.setUploadInProgress)(true));
                  dispatch((0, _actions.selectDirectorVideoRequest)());
                  handler.emit('event://start-video-upload', {
                    name: file.name,
                    size: file.size,
                    memorialId: memorialId
                  });
                  handler.on('event://ready-for-next-video-slice', handleUploadNextSlice);
                  handler.on('event://finished-video-upload', handleFinishUpload);
                  streamProps = {
                    dispatch: dispatch,
                    handler: handler,
                    file: file
                  };
                }
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref28.apply(this, arguments);
    };
  }();
};

exports.startUploadDirectorVideo = startUploadDirectorVideo;

var resetDirectorVideoUpload = function resetDirectorVideoUpload() {
  return function (dispatch) {
    dispatch((0, _actions.resetDirectorVideoUpload)());
  };
};

exports.resetDirectorVideoUpload = resetDirectorVideoUpload;